module.exports = __webpack_public_path__ + "img/info-icon.24fdc779.svg";